// extracted by mini-css-extract-plugin
export default {"found":"notfound_found__Hujjm"};